import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import imgUrl from '../../assets/images/imageUrl';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import AccountCircle from '@material-ui/icons/AccountCircle';
import TranslateIcon from '@material-ui/icons/Translate';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import WorkIcon from '@material-ui/icons/Work';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTint } from '@fortawesome/free-solid-svg-icons';
import OfflineDb from '../../db';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(0),
  },
}));

const userRole = [
  'Health Provider',
  'Beneficiary',
  'GuestUser'
];

function Onboarding({ onSuccess }) {
  const classes = useStyles();
  const history = useHistory();
  const [language, setlanguage] = useState('');
  const [location, setlocation] = useState('');
  const [userrole, setuserrole] = useState('');

  useEffect(() => {
    OfflineDb.getDataFromPouchDB('loginDetails')
      .then(loginDetails => {
        if (loginDetails.data !== undefined) {
          if (localStorage.getItem('userrole') && localStorage.getItem('userrole') !== 'Health Provider') {
            onSuccess();
          } else {
            onSuccess();
          }
        }
      });
  }, []);

  const handleLanguageChange = (event) => setlanguage(event.target.value);
  const handleLocationChange = (event) => setlocation(event.target.value);
  const handleUserRoleChange = (userrole) => {
    setuserrole(userrole);
    if (userrole === "Health Provider") {
      history.push('/login');
    }
    if (userrole === "Patient") {
      history.push('/phonenumberlogin');
    }
    if (userrole === "Facilty") {
      history.push('/login');
      localStorage.setItem("facilty", true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem('language', language);
    localStorage.setItem('location', location);
    localStorage.setItem('userrole', userrole);
    history.push('/login');
  };

  return (
    <div className={window.cordova ? "onboardingPage" : 'onboardingPage windowdesktop'}>
      <section
        className="mainsection onboardingSection pb-0"
        style={{ flexGrow: 1 }}
      >
        <Grid container className="homelanding homemain">
          <Grid item xs={12} className="pl-0px homeholder">
            <div className="homeholder h-100">
              <Grid container className='homeholdergrid margin-top-0'>
                <Grid item xs={12} className="text-center vert-center">
                <Typography variant="h2" style={{ fontWeight: 'bold'}} className="clini-head">
                  <FontAwesomeIcon
                    icon={faTint}
                    style={{
                      marginRight: '5px',
                      fontSize: '1.2em',
                    }}
                  />
                  DROP
                </Typography>
                  <Typography variant="h4" className="clini-head mt-20px">
                    Diabetes Registry of Pakistan
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                xs={12}
                lg={12}
                className="userselectgrid"
                style={{
                  paddingBottom: '20px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Grid
                  container
                  xs={12}
                  md={6}
                  lg={6}
                  sm={6}
                  className="onboardSelect left right"
                  style={{ textAlign: 'center', border: '1px solid #ddd', borderRadius: '70px', padding: '20px' }}
                >
                  <Grid item xs={12} lg={5} md={5} className="providerimggrid">
                    <div className="providerimg text-center pos-relative">
                      <img src={imgUrl['prov-home']} className="patientImg" />
                    </div>
                  </Grid>
                  <Grid item xs={12} lg={7} md={7} className="text-center vert-center h-100 borderonboard">
                    <Button
                      variant="filled"
                      className="onboardBtn"
                      onClick={() => handleUserRoleChange('Health Provider')}
                    >
                      <img src={imgUrl['map-doctor']} className="doc-logo" />
                      HCP
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </section>
    </div>
  );
}

export default Onboarding;
